import { render, staticRenderFns } from "./HomePartner.vue?vue&type=template&id=3ae87ebb&scoped=true&"
import script from "./HomePartner.vue?vue&type=script&lang=js&"
export * from "./HomePartner.vue?vue&type=script&lang=js&"
import style0 from "./HomePartner.vue?vue&type=style&index=0&id=3ae87ebb&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae87ebb",
  null
  
)

export default component.exports